import { confirmTestSend } from "./confirmTestSend";
const defaultHeaders = { "Content-Type": "application/json" };
export const ORGANIZE_PUBLIC_ORIGIN = "https://organize.virtualmedica.com";

export function organizePublicUrl(path: string) {
  return new URL(path, `${ORGANIZE_PUBLIC_ORIGIN}/`).toString();
}

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  let response = await fetch(path, {
    credentials: "include",
    ...options,
    headers: { ...defaultHeaders, ...(options.headers || {}) },
  });
  let payload = await response.json().catch(() => ({}));
  while (response.status === 428 && payload.testSendPreview && payload.confirmationToken) {
    if (!await confirmTestSend(payload.testSendPreview)) throw new ApiError("Envío cancelado. No se enviaron mensajes.",499);
    response = await fetch(path, {
      credentials:"include", ...options,
      headers:{...defaultHeaders,...(options.headers || {}),"X-Test-Send-Confirmation":payload.confirmationToken},
    });
    payload = await response.json().catch(() => ({}));
  }
  if (payload.testMode && payload.testSummary) {
    const {default: Swal} = await import("sweetalert2");
    const rows = payload.testSummary.channels || [];
    const counts = (channel: string, status: string) => rows.filter((r: {channel:string;status:string}) => r.channel === channel && r.status === status).reduce((n:number,r:{count:number}) => n + r.count, 0);
    await Swal.fire("Test de Envíos", `Enviados a los destinos de prueba: ${counts("email","sent")} emails y ${counts("whatsapp","sent")} WhatsApp. Omitidos por el límite: ${payload.testSummary.skipped || 0}. Errores: ${counts("email","error") + counts("whatsapp","error")}. No se notificó a los destinatarios reales.`, "info");
  }
  if (!response.ok) throw new ApiError(payload.error || "No se pudo completar la operación", response.status);
  return payload as T;
}

export function eventQuery(eventId: number, params: Record<string, string | number | undefined> = {}) {
  const query = new URLSearchParams({ eventId: String(eventId) });
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== "") query.set(key, String(value));
  }
  return query.toString();
}
